module.exports = __webpack_public_path__ + "img/fcm-logotipo.4ab3cadc.svg";